<template>
<!-- pr-0 -->
    <v-container fluid class="pl-0">
        <v-row>
            <v-col>
                <v-data-table
                    :headers="warehousesHeaders"
                    :items="item.warehousesRows"
                    :expanded.sync="expandedItems"
                    show-expand
                    @click:row="expandItemByClick($event)"
                    :header-props="{ sortIcon: '' }"
                    :items-per-page="itemsPerPage"
                    hide-default-footer
                    :no-data-text="$t('lang_GENERAL_MESSAGE_NO_RECORDS_FOUND')"
                    class="noMinWidth"
                >
                <!-- Warehouses alvqas -->
                    <template v-for="(header, i) in warehousesHeaders" v-slot:[`header.${header.value}`]>
                        <span :alvqa="header.alvqa" :key="i">{{ header.text }}</span>
                    </template>

                <!-- Items -->
                    <!-- Expand Icon -->
                    <template v-slot:[`item.data-table-expand`]="{ isExpanded }">
                        <v-icon 
                            v-if="isExpanded"
                            small 
                            class="ma-0 pa-0"
                            color="buttonStandard"
                        >fa-arrow-alt-circle-down</v-icon>
                        <v-icon 
                            v-else
                            small 
                            class="ma-0 pa-0"
                            color="buttonStandard"
                        >fa-arrow-alt-circle-right</v-icon>
                    </template>

                    <!-- EXPANDED ITEM -->
                    <template v-slot:expanded-item="{ item }">
                        <td
                            colspan="1"
                            style="background-color: var(--v-expandPanelBackground-base);"
                        ></td>
                        <td 
                            class="pl-0"
                            :colspan="warehousesHeaders.length - 1"
                            style="background-color: var(--v-expandPanelBackground-base);"
                        >
                            <v-container fluid class="pl-0 pr-0">
                                <v-row>
                                    <v-col class="pr-0">
                                        <v-data-table
                                            :headers="movementsGroupsHeaders"
                                            hide-default-footer
                                            :items="item.movements"
                                            :header-props="{ sortIcon: '' }"
                                            :items-per-page="itemsPerPage"
                                            class="noMinWidth"
                                        >
                                        <!-- Contract groups Headers -->
                                            <template v-for="(header, i) in movementsGroupsHeaders" v-slot:[`header.${header.value}`]>
                                                <span :alvqa="header.alvqa + '-' + item.sheetNumber" :key="i">{{ header.text }}</span> 
                                            </template>
                                            
                                            <template v-slot:[`item.senderReceiver`]="{ item }">
                                                {{ getSenderReceiver(item.senderReceiver, item.typeOfDocument) }}
                                            </template>

                                            <template v-slot:[`item.typeOfDocument`]="{ item }">
                                                {{ $t(item.typeOfDocument) }}
                                            </template>

                                            <template v-slot:[`item.date`]="{ item }">
                                                {{ $d(new Date(item.date), 'alvDateFormat', $i18n.locale) }}
                                            </template>

                                            <template v-slot:[`item.additionalInformation`]="{ item }">
                                                {{ getAdditionalInformation(item.additionalInformation, item.typeOfDocument) }}
                                            </template>                                            

                                        </v-data-table>
                                    </v-col>
                                </v-row>
                            </v-container>
                        </td>
                    </template>
                </v-data-table>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
import BaseIcon from '@/components/_buttons/BaseIcon'
import BaseTooltip from '@/components/_base/BaseTooltip'

export default {
    name: "InventoriesReadonly",
    props: {
        itemId: {
            type: Number
        }
    },
    components: {
        BaseIcon,
        BaseTooltip
    },
    data() {
        return {
            expandedItems: [],
            alvqa: 'erp-inventories-list-row-' + this.itemId + '-read-only'
        }
    },
    computed: {
        item() {
            let item = this.$store.getters.getExpandedInventories.find(element => element.id === this.itemId)
            return item
        },

        warehousesHeaders() {
            return [
                {
					text: '', 
					value: 'data-table-expand',
					align: 'center', 
                    sortable: false,
					width: "48px"
				},
                {
                    text: this.$t("lang_GENERIC_CAPTION_WAREHOUSES"), 
                    value: 'warehouseTitle', 
                    align: 'left', 
                    sortable: false,
                    width: "200px",
                    alvqa: this.alvqa + '-warehouse-title'
                },
                {
                    text: this.$t('lang_ERP_SHIPPING_DROPDOWN_BATCH_SALES'), 
                    value: 'batchSales',
                    align: 'right', 
                    sortable: false,
                    width: "80px",
                    alvqa: this.alvqa + '-warehouse-batch-sales'
                },
                {
                    text: this.$t('lang_ERP_SHIPPING_DROPDOWN_BATCH_PROMO'), 
                    value: 'batchPromo',
                    align: 'right', 
                    sortable: false,
                    width: "80px",
                    alvqa: this.alvqa + '-warehouse-batch-promo'
                },
                {
                    text: this.$t('lang_ERP_SHIPPING_DROPDOWN_BATCH_FOC'), 
                    value: 'batchFoc',
                    align: 'right', 
                    sortable: false,
                    width: "80px",
                    alvqa: this.alvqa + '-warehouse-batch-foc'
                },
                {
                    text: this.$t('lang_ERP_SHIPPING_DROPDOWN_BATCH_PST'), 
                    value: 'batchPst',
                    align: 'right', 
                    sortable: false,
                    width: "80px",
                    alvqa: this.alvqa + '-warehouse-batch-pst'
                },
				{
					text: '', 
					value: 'ghost',
					sortable: false,
                    // width: "1%",
                    class: 'text-no-wrap'
				},
            ]
        },

        movementsGroupsHeaders() {
            return [
                {
                    text: this.$t("lang_ERP_INVENTORIES_CAPTION_SENDER_RECEIVER"), 
                    value: 'senderReceiver', 
                    align: 'left', 
                    sortable: false,
                    width: "200px",
                    alvqa: this.alvqa + '-movements-sender-receiver'
                },
                {
                    text: "", 
                    value: 'batchSales', 
                    align: 'right', 
                    sortable: false,
                    width: "80px",
                    alvqa: this.alvqa + '-movements-batch-sales'
                },
                {
                    text: "", 
                    value: 'batchPromo', 
                    align: 'right', 
                    sortable: false,
                    // class: 'text-no-wrap',
                    width: "80px",
                    alvqa: this.alvqa + '-movements-batch-promo'
                },
                {
                    text: "", 
                    value: 'batchFoc', 
                    align: 'right', 
                    sortable: false,
                    // class: 'text-no-wrap',
                    width: "80px",
                    alvqa: this.alvqa + '-movements-batch-foc'
                },
                {
                    text: "", 
                    value: 'batchPst', 
                    align: 'right', 
                    sortable: false,
                    // class: 'text-no-wrap',
                    width: "80px",
                    alvqa: this.alvqa + '-movements-batch-pst'
                },
                {
                    text: this.$t("lang_ERP_INVENTORIES_CAPTION_TYPE_OF_DOCUMENT"), 
                    value: 'typeOfDocument', 
                    align: 'right', 
                    sortable: false,
                    // class: 'text-no-wrap',
                    width: "150px",
                    alvqa: this.alvqa + '-movements-type-of-document'
                },
                {
                    text: this.$t("lang_GENERIC_CAPTION_DATE"), 
                    value: 'date',
                    align: 'right', 
                    sortable: false,
                    // class: 'text-no-wrap',
                    width: "120px",
                    alvqa: this.alvqa + '-movements-date'
                },
                {
                    text: this.$t("lang_ERP_INVENTORIES_CAPTION_ID_OF_DOCUMENT"), 
                    value: 'idOfDocument', 
                    align: 'right', 
                    sortable: false,
                    // class: 'text-no-wrap',
                    width: "150px",
                    alvqa: this.alvqa + '-movements-id-of-document'
                },
                {
                    text: this.$t("lang_GENERIC_CAPTION_ADDITIONAL_INFORMATION"), 
                    value: 'additionalInformation', 
                    align: 'left', 
                    sortable: false,
                    // class: 'text-no-wrap',
                    width: "350px",
                    alvqa: this.alvqa + '-movements-additional-information'
                },
                {
					text: '', 
					value: 'ghost',
					sortable: false,
                    // width: "1%",
                    class: 'text-no-wrap'
				}
            ]
        },

        itemsPerPage() { return this.$store.getters.getItemsPerPage },
    },
    methods: {
        // Expand behaviour when clicking on a row. 
        async expandItemByClick(item) {            
            if(this.expandedItems.includes(item)) { // close item.
                let indexOfItem = this.expandedItems.indexOf(item)
                this.expandedItems.splice(indexOfItem, 1) 
            } else { // open item             
                this.expandedItems.push(item) 
            }
        },
        getSenderReceiver(senderReceiver, typeOfDocument) {
            if (typeOfDocument != null) {
                if (typeOfDocument == 'lang_ERP_INVENTORIES_DOCUMENT_TYPE_INVENTORY_DATA' || typeOfDocument == 'lang_ERP_INVENTORIES_DOCUMENT_TYPE_STOCK_CORRECTION')
                    return this.$t('lang_ERP_INVENTORIES_CAPTION_UPLOADED_BY') + " " + senderReceiver
                else
                    return senderReceiver
            }
        },
        getAdditionalInformation(additionalInformation, typeOfDocument) {
            if (typeOfDocument != null) {
                if (typeOfDocument == 'lang_ERP_INVENTORIES_DOCUMENT_TYPE_INVENTORY_DATA' || typeOfDocument == 'lang_ERP_INVENTORIES_DOCUMENT_TYPE_STOCK_CORRECTION')
                    return this.$t('lang_ERP_INVENTORIES_CAPTION_UPLOADED_ON') + ": " + this.$d(new Date(additionalInformation), 'alvDateFormat', this.$i18n.locale)
                else
                    return additionalInformation
            }
        },
    }
}
</script>

<style>
    .noMinWidth table {
        min-width: 0px !important;
        table-layout: fixed;
    }
</style>